/*
# -----------------------------------------------------------------------------
# Component: receiptsListMixin.js
# Author: antonio.ramirez@pst.sg
# Created Date: 02/April/2019
# Comments: Responsible for all data table related functionality
# -----------------------------------------------------------------------------
*/
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'

export const receiptsListMixin = {
  data() {
    return {
      totalItems: 0,
      items: [],
      selectedPage: 0,
      selectedReceiptsColumns: ['branch', 'acctNo', 'docNo', 'tranDate', 'curr', 'amount', 'gst', 'bankAmount', 'localBankAmount'],
      receiptsColumns: [
        { text: 'Branch', value: 'branch' },
        { text: 'Acct. No.', value: 'acctNo' },
        { text: 'Doc. No.', value: 'docNo' },
        { text: 'Date', value: 'tranDate' },
        { text: 'Currency', value: 'curr' },
        { text: 'Amount', value: 'amount' },
        { text: 'GST', value: 'gst' },
        { text: 'Bank Amount', value: 'bankAmount' },
        { text: 'Local Bank Amount', value: 'localBankAmount' }
      ],
      firstTimeCalling: true
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    listReceiptHeaders() {
      let result = []
      for (const selectedReceiptsColumn of this.selectedReceiptsColumns) {
        let findCol = this.receiptsColumns.find(a => selectedReceiptsColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  watch: {
    'pagination': function (value) {
      if (this.firstTimeCalling === false) {
        this.performSearch(false)
      }
    }
  },
  mounted() {
    this.getBranchList()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
